module.exports = __webpack_public_path__ + "img/navbar_logo.8332570f.png";